import React from 'react';
import { NavLink } from 'react-router-dom';

// <nav>
//     <ul>
//         <li><NavLink to="/">Home</NavLink></li>
//         <li><NavLink to="/essays">Essays</NavLink></li>
//         {/* <li><NavLink to="/pod">Podcast</NavLink></li> */}
//         <li><NavLink to="/resources">Resources</NavLink></li>
//     </ul>
// </nav>

const Header = () => {
    return (
        <header>
            <h1>kipruto.net</h1>
            <p>writer & technologist</p>
             <div className='social-links'>
                <a target="_blank" rel="noopener noreferrer" href='https://www.tiktok.com/@kipruto.net'>tiktok</a>
                <a target="_blank" rel="noopener noreferrer" href='https://www.instagram.com/kipruto.insta'>instagram</a>
                <a target="_blank" rel="noopener noreferrer" href='https://patreon.com/kipruto_net?utm_medium=unknown&utm_source=join_link&utm_campaign=creatorshare_creator&utm_content=copyLink'>patreon</a>
            </div>
            {/* <a href="#">join mailing list</a> */}
        </header>
    );
};

//mental health abolitionist, game developer, & artist
//abolitionist & technologist

export default Header;